import React, { useContext, useState } from 'react';

import { useMutation } from 'react-query';
import {useNavigate} from 'react-router-dom';
import { AuthServiceInstance } from 'services/authService';
import { AuthStoreContext } from 'store/AuthStore';
import { AllErrors, NotAuthorizedError, NotFoundError } from 'types/Errors';

import { LoginGeneratedProps } from './Login.props';
import LoginView from './Login.view';

const Login = (): JSX.Element => {
  // MARK:- Store
  const authStore = useContext(AuthStoreContext);

  // MARK:- Hooks
  const navigate = useNavigate();

  // MARK:- State
  const [errorMessage, setErrorMessage] = useState('');

  // MARK:- Mutations
  const loginMutation = useMutation(AuthServiceInstance.login, {
    onSuccess: (data) => {
      authStore.onLogin(data);
      navigate('/dashboard');
    },
    onError: (error: AllErrors) => {
      if (error instanceof NotFoundError) {
        setErrorMessage('Email is not found in the database!');
        return;
      }

      if (error instanceof NotAuthorizedError) {
        setErrorMessage('Password is invalid!');
        return;
      }

      setErrorMessage('An unexpected error has occurred!');
    },
  });

  // MARK:- Functions
  function onLogin(email: string, password: string) {
    loginMutation.mutate({ email, password });
  }

  const generatedProps: LoginGeneratedProps = {
    onLogin,
    errorMessage,
    loading: loginMutation.isLoading,
  };
  return <LoginView {...generatedProps} />;
};

export default Login;
